import { gql } from '@apollo/client'

export const HUBSPOT_EXPORT_CUSTOMERS_MUTATION = gql`
  mutation ExportCustomers($input: HubSpotExportFilterDtoInput!) {
    exportCustomers(input: $input) {
      success
      errorMessage
      statusCode
      content
      statusDescription
      totalProcessedRecords
      successfulRecords
      failedRecords
    }
  }
`

export const HUBSPOT_EXPORT_CONTACTS_MUTATION = gql`
  mutation ExportContacts($input: HubSpotExportFilterDtoInput!) {
    exportContacts(input: $input) {
      success
      errorMessage
      statusCode
      content
      statusDescription
      totalProcessedRecords
      successfulRecords
      failedRecords
    }
  }
`

export const HUBSPOT_EXPORT_BOOKINGS_MUTATION = gql`
  mutation ExportBookings($input: HubSpotExportFilterDtoInput!) {
    exportBookings(input: $input) {
      success
      errorMessage
      statusCode
      content
      statusDescription
      totalProcessedRecords
      successfulRecords
      failedRecords
    }
  }
`
export const HUBSPOT_EXPORT_LOCATION_PROPERTY_MUTATION = gql`
  mutation ExportCustomerCities {
    exportCustomerCities {
      success
      errorMessage
      statusCode
      content
      statusDescription
    }
  }
`

export const HUBSPOT_EXPORT_SERVICE_TYPE_PROPERTY_MUTATION = gql`
  mutation ExportServiceCodes {
    exportServiceCodes {
      success
      errorMessage
      statusCode
      content
      statusDescription
    }
  }
`

export const HUBSPOT_EXPORT_VEHICLE_PROPERTY_MUTATION = gql`
  mutation ExportTariffCategories {
    exportTariffCategories {
      success
      errorMessage
      statusCode
      content
      statusDescription
    }
  }
`

export const HUBSPOT_OBJECT_EXPORT_RETRY_MUTATION = gql`
  mutation HubSpotObjectExportRetry($input: HubSpotExportRetryDtoInput!) {
    hubSpotObjectExportRetry(input: $input) {
      success
      errorMessage
      statusCode
      content
      statusDescription
      totalProcessedRecords
    }
  }
`

export const HUBSPOT_UPDATE_CONTACT_LINKED_RECORD_MUTATION = gql`
  mutation UpdateContactHubSpotLinkedRecord($input: UpdateContactHubSpotLinkedRecordDtoInput!) {
    updateContactHubSpotLinkedRecord(input: $input) {
      id
      hubSpotObjectId
      hubSpotSyncDate
      name
      email
    }
  }
`

export const HUBSPOT_UPDATE_CUSTOMER_LINKED_RECORD_MUTATION = gql`
  mutation UpdateCustomerHubSpotLinkedRecord($input: UpdateCustomerHubSpotLinkedRecordDtoInput!) {
    updateCustomerHubSpotLinkedRecord(input: $input) {
      id
      hubSpotObjectId
      hubSpotSyncDate
      name
    }
  }
`
